import { type FC } from "react";

import { Checkbox } from "@snapchat/snap-design-system";

import {
    GuidelinesTitle,
    TermsAndConditions1,
    TermsAndConditions2,
    TermsAndConditions3,
    TermsOfServiceTitle,
} from "../../messages.generated";

import { checkbox } from "./eula.styles";

interface CreateApiFormEulaProps {
    agreement: boolean;
    setAgreement: (val: boolean) => void;
}

export const CreateApiFormEula: FC<CreateApiFormEulaProps> = ({ agreement, setAgreement }) => {
    return (
        <Checkbox
            containerClassName={checkbox}
            value={agreement}
            onChange={(val: boolean) => {
                setAgreement(val);
            }}
            label={
                <span>
                    <TermsAndConditions1 />
                    <a href="https://snap.com/en-US/terms" rel="noreferrer" target="_blank">
                        <TermsOfServiceTitle />
                    </a>
                    <TermsAndConditions2 />
                    <a href="https://snap.com/en-US/community-guidelines" rel="noreferrer" target="_blank">
                        <GuidelinesTitle />
                    </a>
                    <TermsAndConditions3 />
                </span>
            }
        />
    );
};
